import React from "react";
import { Layout } from "./Layout";
import { Table } from "./Table";
import { ListingProps } from "../types";

export const Listing = <Data extends Record<string, any>, Context extends any = any>({
  columns,
  tableData,
  injectContext,
  loading = false,
  ...layoutProps
}: ListingProps<Data, Context>) => {
  const context = injectContext || ({ context: "Empty" } as Context);

  return (
    <Layout<Context>
      context={context}
      table={<Table<Data, Context> columns={columns} loading={loading} tableData={tableData} context={context} />}
      {...layoutProps}
    />
  );
};
